export default {
    data() {
        return {
        }
    },
    computed: {
    },
    watch: {
        player(val) {
            if (val) {
                this.initPlayer()
            }
        },
        'innerValue.end'(time) {
            this.changePlayerTime(time)
        },
        'innerValue.start'(time) {
            this.changePlayerTime(time)
        },
    },

    created() {
    },
    mounted() {
    },
    methods: {
        initPlayer() {
            // listen to timeupdate, playing, paused
            if (this.player) {
                this.player.$on('timeupdate', this.updateTimeLine)
            }
        },
        changePlayerTime(time) {
            this.player?.pause?.()
            this.player?.moveTo?.(time)
        },
    }
}
